import { Component } from 'react'

import Request from './Request/Request'

class Posts extends Component {
	static list() {
		return Request.get('/posts')
	}

	static get(postSlug, options) {
		let url = `/posts/${postSlug}`

		if (options.populate) {
			url += `?populate=${options.populate.join(',')}`
		}

		return Request.get(url)
	}
}

export default Posts


// WEBPACK FOOTER //
// ./src/services/Posts.js